// extracted by mini-css-extract-plugin
export var loadingSpinner = "_42-1";
export var standaloneTable = "_42-0";